import {Pipe, PipeTransform} from '@angular/core';
import {TicketsService} from '../../services/tickets.service';

@Pipe({
  name: 'versionintegration',
  standalone: true,
})
export class VersionIntegrationStripPipe implements PipeTransform {

  possibleVersions: Map<string, string>;

  constructor(private ticketService: TicketsService) {
    this.ticketService.getPossibleVersionsIntegration().subscribe(val => {
      this.possibleVersions = val;
    });
  }

  transform(version: string): string {
    if (version == null || this.possibleVersions === undefined || this.possibleVersions[version] === undefined) {
      return '';
    }
    return this.possibleVersions[version];
  }
}
